'use client'
import { useUser } from '@/app/_hooks'
import { NotificationType } from '@/types/common/notification'
import { PATH_OCP } from '@/utils/pageRoutes'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { Notification } from '@/components'

interface AccordionMenuProps {
  title: string
  pages: { label: string; href: string; locked?: boolean }[]
}

interface Page {
  label: string
  href: string
  locked?: boolean | undefined
}

type UserList = {
  authType: string
  isHolidayTest: boolean
  systemType: string
}

let colorCode = '#A0A0A0'

// 環境識別の為にサイドメニュー色を変更
if (process.env.NEXT_PUBLIC_ENV === 'uat') {
  colorCode = '#FFEDB3'
} else if (process.env.NEXT_PUBLIC_ENV === 'dev') {
  colorCode = '#8ABD87'
}

const AccordionMenu = ({ title, pages }: AccordionMenuProps) => {
  return (
    <>
      <Accordion sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
        <AccordionSummary
          sx={{ px: 0, minHeight: 'auto', my: 0 }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography color='#111111' fontSize={14} fontWeight={700}>
            {title}
          </Typography>
        </AccordionSummary>
        <Box p={1}>
          <AccordionDetails
            sx={{
              borderLeft: '1px solid rgba(17, 17, 17, 0.4)',
              p: '0px 0px 0px 16px',
            }}
          >
            <Stack gap={1.5}>
              {pages.map((page: Page, index: number) => (
                <Stack
                  direction='row'
                  justifyContent='space-between'
                  alignItems='center'
                  key={index}
                >
                  <Link
                    href={page.href}
                    key={page.href}
                    style={{
                      color: 'rgba(17, 17, 17, 0.6)',
                      textDecoration: 'none',
                    }}
                  >
                    {page.label}
                  </Link>
                  {page.locked && (
                    <Image src='/lock.svg' width={14} height={14} alt='lock' />
                  )}
                </Stack>
              ))}
            </Stack>
          </AccordionDetails>
        </Box>
      </Accordion>
    </>
  )
}

export const SideMenu = ({ toggle }: { toggle: boolean }) => {
  // notification
  const [notification, setNotification] = useState<NotificationType>({
    open: false,
    severity: 'success',
    msg: '',
  })
  const { result: userResult, isLoading: userIsLoading } = useUser({
    setNotification,
  })

  return (
    <>
      <Notification {...{ notification, setNotification }} />
      <Stack
        justifyContent='space-between'
        width={250}
        bgcolor={colorCode}
        p={4}
        display={toggle ? 'flex' : 'none'}
      >
        <Stack gap={5}>
          <Link href='/'>
            <Image src='/logo.png' width={102} height={34.6} alt='logo' />
          </Link>

          <Stack gap={2.5}>
            {userIsLoading ? (
              <Skeleton />
            ) : (
              userResult?.list &&
              userResult.list.map((param: UserList) => {
                const { systemType } = param
                if (systemType === 'ssconfirm') {
                  return (
                    <AccordionMenu
                      key={systemType}
                      title='決済照合'
                      pages={[
                        { label: '決済予定明細情報', href: PATH_OCP },
                        // { label: '小項目1', href: '/', locked: true },
                      ]}
                    />
                    // <AccordionMenu
                    //   title='大項目1'
                    //   pages={[
                    //     { label: '小項目1', href: '/' },
                    //     { label: '小項目1', href: '/' },
                    //   ]}
                    // />
                  )
                }
              })
            )}
          </Stack>
        </Stack>
        {/* <Link href='/' style={{ textDecoration: 'none' }}>
        <Stack direction='row' alignItems='center' gap={1}>
          <Image src='/info.svg' width={20} height={20} alt='info' />
          <Typography
            color='rgba(17, 17, 17, 0.4)'
            fontSize={14}
            fontWeight={700}
          >
            操作マニュアル
          </Typography>
        </Stack>
      </Link> */}
      </Stack>
    </>
  )
}
